import { getFullPath, routes } from "../routes";
import { Navigate, useParams } from "react-router";
import { ProjectForm } from "./ProjectForm";
import { useProject } from "./hooks";

export function EditProject() {
  const { id } = useParams();
  const { data, isLoading, isError } = useProject(id);

  if (isLoading) {
    return <p>Loading...</p>;
  } else if (isError) {
    return <p>An unknown error occurred.</p>;
  } else if (data) {
    return <ProjectForm data={data} />;
  } else {
    return <Navigate to={getFullPath(routes.project.create)} />;
  }
}
